import { Component } from '@angular/core';
import { FileUploadComponent } from "../file-upload/file-upload.component";
import { FormGroup } from '@angular/forms';
import { FormStateService } from '../../services/form-state.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-branding-info-form',
  imports: [FileUploadComponent],
  templateUrl: './branding-info-form.component.html',
  styleUrl: './branding-info-form.component.scss'
})
export class BrandingInfoFormComponent {
  
    signUpForm!: FormGroup;
    brandingInfoForm!: FormGroup;
    
    constructor(private formStateService: FormStateService, private router: Router) {
      // Assign signUpForm after the service is initialized
      this.signUpForm = this.formStateService.getForm();     
      this.brandingInfoForm = this.signUpForm.get('brandingInformation') as FormGroup;
    }

  updateLogo(files: File[]) {
    if (files.length > 0) {
      this.convertFileToBase64(files[0]).then(base64 => {
        this.brandingInfoForm?.patchValue({ logo: base64 });
        this.brandingInfoForm?.get('logo')?.markAsTouched();
      });
    } else {
      this.brandingInfoForm?.patchValue({ logo: '' });
      this.brandingInfoForm?.get('logo')?.markAsUntouched();
    }
  }

  updateIcon(files: File[]) {
    if (files.length > 0) {
      this.convertFileToBase64(files[0]).then(base64 => {
        this.brandingInfoForm?.patchValue({ icon: base64 });
        this.brandingInfoForm?.get('icon')?.markAsTouched();
      });
    } else {
      this.brandingInfoForm?.patchValue({ icon: '' });
      this.brandingInfoForm?.get('icon')?.markAsUntouched();
    }
  }

  private convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }

}
